import { render, staticRenderFns } from "./Top10KundenBereichUmsatz.vue?vue&type=template&id=08e1784b&"
import script from "./Top10KundenBereichUmsatz.vue?vue&type=script&lang=ts&"
export * from "./Top10KundenBereichUmsatz.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports